const en = {
  // common
  'Loading...': 'Cargando...',
  'No data': 'Sin datos',
  Yes: 'Sí',
  No: 'No',
  Imperial: 'Sistema imperial',
  Metric: 'Métrico',
  Bar: 'bar',
  bar: 'bar',
  'm^3/min': 'm^3/min',
  'm3/min': 'm<0>3</0>/min',
  kW: 'kW',
  'SPECIFIC POWER': 'POTENCIA ESPECÍFICA',
  pressure: 'Presión',
  'operation mode': 'Modo de operación',
  flow: 'flujo',
  power: 'Potencia',
  PSI: 'psi',
  psi: 'psi',
  CFM: 'CFM',
  cfm: 'cfm',
  RPM: 'RPM',
  temperature: 'temperatura',
  Temperature: 'Temperatura',
  Celsius: 'Celsius',
  celsius: 'celsius',
  Fahrenheit: 'Fahrenheit',
  fahrenheit: 'fahrenheit',
  '°C': '°C',
  '°F': '°F',
  current: 'corriente',
  'Oil temperature': 'Temperatura del aceite',
  'Dew point temperature': 'Temperatura del punto de rocío',
  'Inverter speed': 'Velocidad del inversor',
  'Run hours': 'Horas de funcionamiento',
  'Load hours': 'Horas de carga',
  '_ _': ' _ _',
  'N/A': 'N/C',
  'Water Flow': 'Flujo del agua',
  'Inlet Water Temperature': 'Temperatura del agua de entrada',
  'Outlet Water Temperature': 'Temperatura del agua de salida',

  // login page
  'Welcome to EcoPlant': 'Bienvenido a EcoPlant',
  'For technical support email us at:': 'Para asistencia técnica envíenos un correo electrónico a:',
  'EcoPlant 2025. All right reserved.': 'EcoPlant 2025. Todos los derechos reservados.',
  'Email Address': 'Dirección de correo electrónico',
  Password: 'Contraseña',
  Login: 'Inicio de sesión',
  'Enter a verification code': 'Introduzca un código de verificación',
  'Send Again': 'Enviar de nuevo',
  Done: 'Hecho',
  Cancel: 'Cancelar',
  'SMS with a verification code was sent to your phone':
    'Se ha enviado un SMS con un código de verificación a su teléfono',
  'Forgot Password': 'Contraseña olvidada',
  'Sign in with Single Sign On': 'Iniciar sesión con Inicio de sesión único',

  // side menu
  "Eco plant's logo": 'Logotipo de Eco plant',
  'Log out': 'Cerrar sesión',

  // eco score card
  'ECO RATING': 'CALIFICACIÓN ECOLÓGICA',
  'Specific power': 'Potencia específica',
  'kW/(m^3/min)': 'kW/(m^3/min)',
  'kW/(m3/min)': 'kW/(m<0>3</0>/min)',
  'm^3': 'm<0>3</0>',
  'ft^3': 'ft<0>3</0>',
  'kW/100CFM': 'kW/100CFM',

  // alerts
  ALERTS: 'ALERTAS',
  All: 'Todas',
  Service: 'Servicio',
  service: 'servicio',
  Warning: 'Advertencia',
  warning: 'advertencia',
  Shutdown: 'Apagado',
  shutdown: 'apagado',
  Expired: 'Expirado',
  Custom: 'Personalizado',
  Manufacturer: 'Fabricante',
  'No more alerts to show': 'No se muestran más alertas',
  'No alerts to show for this severity type.': 'No hay alertas para mostrar para este tipo de gravedad.',
  RECOMMENDATION: 'RECOMENDACIÓN',
  'No archived alerts yet.': 'Todavía no hay alertas archivadas.',
  'Or contact us via:': 'O póngase en contacto con nosotros a través de:',
  noAlertsToShow: 'No se muestran alertas. Puede ver las alertas antiguas en la <1>pestaña Archivos</1>.',
  'Archive Alert': 'Alerta de archivos',
  'Unarchive alert failed': 'Error al desarchivar la alerta',
  "View Alert record's rule (logic)": 'Ver la regla (lógica) del registro de alertas',
  'Auto & manually archived alerts': 'Alertas archivadas automática y manualmente',
  'Received during maintenance': 'Recibidas durante el mantenimiento',
  'This alert record was triggered while the compressor was In-Maintenance':
    'Este registro de alerta se activó mientras el compresor estaba En mantenimiento',
  SSOLoginNotEnabled:
    'Su organización no ha habilitado el inicio de sesión SSO para su dirección de correo electrónico. En su lugar, utilice el método de autenticación por contraseña',
  LoginFailureNoStations:
    'Su intento de inicio de sesión no ha tenido éxito porque actualmente no tiene estaciones asignadas a su cuenta. Póngase en contacto con su administrador de TI para solicitar acceso a las estaciones necesarias.',
  LoginFailurePasswordError:
    'Su intento de inicio de sesión no ha tenido éxito. Error del sistema: {{error}} Si su organización utiliza el inicio de sesión único (SSO), intente iniciar sesión utilizando la opción SSO.',
  LoginFailureUnhautorizedSSO:
    'Su intento de inicio de sesión no ha tenido éxito porque su cuenta SSO no está autorizada. Intente iniciar sesión con otra cuenta SSO o utilice la opción de inicio de sesión con contraseña.',

  // main
  Map: 'Mapa',
  Trends: 'Tendencias',
  Investigation: 'Investigación',
  'Reset zoom': 'Restablecer zoom',
  VALUE: 'valor',
  PLANT: 'planta',
  REPORTS: 'informes',
  ENGINE: 'motor',
  OFFERING: 'oferta',
  SETTINGS: 'ajustes',

  // MapKPI
  'Value may depend on multiple sensors and average values over time.':
    'El valor puede depender de varios sensores y valores promedio a lo largo del tiempo. ',
  moreDetailsInStationControl: 'Ver más detalles en la pestaña Centro de control de la estación',
  moreDetailsInValueDashboard: 'Ver más detalles en la pantalla Tablero de valores',
  'Compressor kW based calculation': 'Cálculo basado en kW del compresor',
  'Flow based on Flow sensor avg at the end of the station':
    'Flujo basado en el promedio del sensor de flujo al final de la estación',
  'Pressure Drop': 'Caída de presión',

  // Trends
  UTC: 'UTC',
  Yesterday: 'Ayer',
  'Last 24 hours': 'Últimas 24 horas',
  'Last 7 days': 'Últimos 7 días',
  'Last 30 days': 'Últimos 30 días',
  'Last 90 days': 'Últimos 90 días',

  Pressure: 'Presión',
  Flow: 'Flujo',
  Power: 'Potencia',
  'Specific Power': 'Potencia específica',
  'specific power': 'potencia específica',
  'Oil temp': 'Temp. del aceite',
  'Dew temp': 'Temperatura de rocío',

  // trends - tooltip
  second: 'segundo',
  seconds: 'segundos',
  minute: 'minuto',
  minutes: 'minutos',
  hour: 'hora',
  hours: 'horas',
  day: 'día',
  week: 'semana',
  month: 'mes',
  '{{value}} {{unit}} average': '{{value}} {{unit}}promedio',

  // device modal
  Run: 'Ejecutar',
  Load: 'Carga',
  LOAD: 'Carga',
  Unload: 'Descarga',
  UNLOAD: 'Descarga',
  Off: 'Apagado',
  OFF: 'Apagado',
  ON: 'Encendido',
  On: 'Encendido',
  Loading: 'Cargando',
  Unloading: 'Descargando',
  Disconnected: 'Desconectado',
  disconnected: 'Desconectado',
  'No State': 'Sin estado',
  NoState: 'Sin estado',
  NO_STATE: 'sin estado',
  capacity: 'capacidad',
  Liter: 'Litro',
  liter: 'litro',
  Gallon: 'Galón',
  gallon: 'galón',
  'pipe diameter': 'diámetro del tubo',
  'pipe material': 'material del tubo',
  inch: 'pulgada',
  mm: 'mm',
  'dew point temperature': 'temperatura del punto de rocío',
  activity: 'actividad',

  STOPPED: 'Detenido',
  Connected: 'Conectado',
  connected: 'Conectado',
  'Not connected': 'No conectado',
  connectivity: 'Conectividad',
  CONNECTION_ERROR: 'error de conexión',

  Auto: 'Automático',
  Manual: 'Manual',
  Controllable: 'Controlable',
  CONTROLLABLE: 'Controlable',
  ON_OFF: 'Encendido/Apagado',
  NOTCONTROLLABLE: 'No controlable',
  NOT_CONTROLLABLE: 'No controlable',
  'On/Off': 'Encendido/Apagado',
  'Not controllable': 'No controlable',
  'Min set point': 'Punto de ajuste mín.',
  'Max set point': 'Punto de ajuste máx.',
  VSD_TARGET: 'Objetivo VSD',
  NEXT_SERVICE_IN: 'siguiente servicio en',
  NEXT_SERVICE_TYPE: 'siguiente tipo de servicio',
  h: 'h',
  Min: 'Mín',
  WORKING_HOURS: 'horas de trabajo',
  HORSE_POWER: 'potencia del motor',
  'control mode': 'Modo de control',

  'filter type': 'tipo de filtro',
  'last service': 'último servicio',
  CYCLE: 'CICLO',
  DUTY: 'CARGA',
  'Sensor Based': 'Basado en sensor',
  'Compressor Estimation': 'Estimación del compresor',
  'kW Based Calculation': 'Cálculo basado en kW',
  'AI Calculation': 'Cálculo de IA',
  'RELATIVE POSITION': 'POSICIÓN RELATIVA',
  'back indication': 'indicación de retroceso',
  'last command': 'última orden',
  'default state': 'estado predeterminado',
  Open: 'Abrir',
  'Last set point': 'Último punto de ajuste',
  'I/O': 'E/S',
  'relative position': 'Posición relativa',
  pressureSetpoints: 'Puntos de ajuste de presión',
  hp: 'CV',
  lp: 'LP',
  lowLimit: 'Límite bajo',
  targetSetpoint: 'Punto de ajuste objetivo',

  // node factory
  Filter: 'Filtro',
  Valve: 'Válvula',
  INLET_VALVE: 'válvula de entrada',
  BYPASS_VALVE: 'válvula de derivación',
  CLOSE: 'cerrar',
  OPEN: 'abrir',
  'Closed Valve - Connected': 'Válvula cerrada - Conectada',
  'Open Valve - Connected': 'Válvula abierta - Conectada',
  'Valve state not found': 'Estado de la válvula no encontrado',
  'Valve - Disconnected': 'Válvula - Desconectada',
  Booster: 'Potenciador',
  Compressor: 'Compresor',
  HP: 'CV',

  'Desiccant Air Dryer': 'Secador de aire desecante',
  Desiccant: 'Desecante',
  drying: 'Secado',
  refrigerating: 'Refrigeración',
  waterPressureSensor: 'Sensor de presión de agua',
  'dew point': 'Punto de rocío',
  DEW_POINT: 'punto de rocío',
  timer: 'Temporizador',
  energySaving: 'ahorro de energía',
  ENERGY_SAVINGS: 'ahorros de energía',
  'Dew Point Sensor': 'Sensor de punto de rocío',
  'Dry Air Tank': 'Tanque de aire seco',
  Dry: 'Seco',
  'Dry tank': 'Tanque seco',
  'Combo Sensor': 'Sensor Combo',
  'Flow Sensor': 'Sensor de flujo',
  'Pressure Sensor': 'Sensor de presión',
  'Production Floor': 'Piso de producción',
  'Refrigerated Air Dryer': 'Secador de aire refrigerado',
  Refrigerated: 'Refrigerado',
  'Wet Air Tank': 'Tanque de aire húmedo',
  Wet: 'Húmedo',
  Maintenance: 'Mantenimiento',

  fixedSpeed: 'Compresor de velocidad fija',
  variableSpeedDrive: 'Compresor de velocidad variable',
  centrifugal: 'Compresor centrífugo',
  fixedSpeed_powerSensor: '$t(velocidadfija)',
  powerSensor_variableSpeedDrive: '$t(velocidadvariable)',
  centrifugal_powerSensor: '$t(centrífugo)',
  booster: '$t(Potenciador)',
  wetAirTank: '$t(Tanque de aire húmedo)',
  dryAirTank: '$t(Tanque de aire seco)',
  desiccantAirDryer: '$t(Secador de aire desecante)',
  refrigeratedAirDryer: '$t(Secador de aire refrigerado)',
  pressureSensor: '$t(Sensor de presión)',
  flowSensor: '$t(Sensor de flujo)',
  flowSensor_pressureSensor: 'Sensor de flujo y presión',
  dewpointSensor: '$t(Sensor de punto de rocío)',
  dewpointSensor_pressureSensor: 'Sensor de punto de rocío y presión',
  ambientHumiditySensor_ambientTemperatureSensor: 'Sensor de humedad y temperatura ambiente',
  ambientHumiditySensor_ambientTemperatureSensor_dewpointSensor:
    'Sensor de humedad, temperatura y punto de rocío ambiente',
  airTemperatureSensor: '$t(SENSOR_TEMPERATURA_AIRE)',
  airFilter: '$t(Filtro)',
  proportionalValve: 'Válvula proporcional',
  openCloseValve: 'Válvula de apertura/cierre',
  spillValve: 'Válvula de derrame',
  productionFloor: '$t(Piso de producción)',
  // alert rules
  'The logic triggering alerts': 'Lógica de activación de alertas',
  'Alert rules management': 'Administración de las reglas de alerta',
  'My rules': 'Mis reglas',
  'No rules to display': 'No hay reglas para mostrar',
  'Rule condition:': 'Condición de la regla:',
  and: 'y',
  or: 'o',
  of: 'de',
  is: 'es',
  greaterThan: 'mayor que',
  equalTo: 'igual a',
  notEqualTo: 'no es igual a',
  greaterThanOrEqualTo: 'mayor que o igual a',
  lessThan: 'menor que',
  lessThanOrEqualTo: 'menor que o igual a',
  'Filter by source': 'Filtrar por fuente',
  'Filter by device': 'Filtrar por dispositivo',
  'Create new rule': 'Crear nueva regla',
  'Rule activation status': 'Estado de activación de la regla ',
  Severity: 'Gravedad',
  'Date created': 'Fecha de creación',
  'Last updated': 'Última actualización',
  'Are you sure you want to start monitoring and alerting on this type of events?':
    '¿Está seguro de que desea iniciar la monitorización y las alertas de este tipo de eventos?',
  'Are you sure you want to stop monitoring and alerting on this type of events?':
    '¿Está seguro de que desea detener la monitorización y las alertas de este tipo de eventos?',
  'Failed to change activation status': 'No se ha podido cambiar el estado de activación',
  'Are you sure you want to delete this rule?': '¿Está seguro de que desea eliminar esta regla?',
  'Failed to delete rule': 'Error al eliminar regla',
  'This alert rule has changed since the record you clicked on. The last change was on':
    'Esta regla de alerta ha cambiado desde el registro en el que hizo clic. El último cambio se produjo el',
  'This alert rule has been deleted': 'Esta regla de alerta ha sido eliminada',
  'You can only turn this alert rule off.': 'Sólo puede desactivar esta regla de alerta.',
  'To modify please contact your system administrator or the Ecoplant support':
    'Para modificarla, póngase en contacto con el administrador del sistema o con el servicio de asistencia de Ecoplant.',
  'New Alert': 'Nueva alerta',

  // create edit rule
  Update: 'Actualizar',
  Create: 'Crear',
  'Create and Activate': 'Crear y Activar',
  'Update a custom rule': 'Actualizar una regla personalizada',
  'Create a custom rule': 'Crear una regla personalizada',
  'Name the alerts and set their severity.': 'Asigne un nombre a las alertas y defina su gravedad.',
  'Define the logic for triggering alerts of different severity levels.':
    'Defina la lógica para activar alertas de diferentes niveles de gravedad.',
  'E.g. High than usual flow causes pressure drop': 'P. ej. Un flujo superior al habitual provoca una caída de presión',
  Description: 'Descripción',
  'E.g. Try do the following...': 'P. ej. Intente hacer lo siguiente...',
  'Alert severity': 'Gravedad de la alerta',
  'Rule name (Title)': 'Nombre de la regla (Título)',
  'Duration (if this rule lasts for x time)': 'Duración (si esta regla dura x tiempo)',
  Immediately: 'Inmediatamente',
  'Choose the parameter you wish to monitor.': 'Elija el parámetro que desea monitorizar.',
  Parameter: 'Parámetro',
  'Choose a device with the above-selected monitored parameter. Select multiple devices to create a rule on a calculated parameter (e.g. Pressure difference between devices).':
    'Elija un dispositivo con el parámetro monitorizado seleccionado anteriormente. Seleccione varios dispositivos para crear una regla sobre un parámetro calculado (p. ej., diferencia de presión entre dispositivos).',
  'Choose the operand and the target value threshold to trigger the alerts.':
    'Elija el operando y el límite de valor objetivo para activar las alertas.',
  Operand: 'Operando',
  'Target value': 'Valor objetivo',
  'Save and activate to start monitoring the parameter and trigger alerts according to the rule.':
    'Guarde y active para iniciar la monitorización del parámetro y activar las alertas según la regla.',
  'Contact us if you have any questions at:': 'Póngase en contacto con nosotros si tiene alguna pregunta en:',
  'Add device': 'Añadir dispositivo',
  'E.g. 6.4': 'P. ej. 6.4',
  'Alert rule updated successfully': 'Regla de alerta actualizada correctamente',
  'Alert rule created successfully': 'Regla de alerta creada correctamente',
  'Follow the math order of operations.': 'Siga el orden matemático de las operaciones.',
  'You dont have enough permission to create an alert, please contact your administrator.':
    'No tiene permisos suficientes para crear una alerta, póngase en contacto con su administrador.',
  'Update manufacturer alert rule': 'Actualizar la regla de alerta del fabricante',
  'Edit this Alert rule appearance': 'Editar el aspecto de esta regla de alerta',
  'Alert rule original details': 'Detalles originales de la regla de alerta',
  'Original rule name (Title)': 'Nombre original de la regla (Título)',
  'Given rule name (Title)': 'Nombre dado a la regla (Título)',
  'E.g. High then usual flow causes pressure drop': 'P. ej. Un flujo superior al habitual provoca una caída de presión',
  'Original description': 'Descripción original',
  'Given description': 'Descripción dada',
  'Device name': 'Nombre del dispositivo',
  'Alert rule ID': 'ID de la regla de alerta',
  'Creation date': 'Fecha de creación',

  //error modal
  'Something went wrong': 'Algo ha salido mal',
  'Please try again later.': 'Vuelva a intentarlo más tarde.',
  Dismiss: 'Descartar',

  //Proactive engine (dynamic controller)
  'Dynamic Controller': 'Controlador dinámico',
  'Controller Mode': 'Modo de controlador',
  Activated: 'Activado',
  Deactivated: 'Desactivado',
  Unavailable: 'No disponible',
  Unknown: 'Desconocido',
  'Dynamic Controller is Activated': 'Controlador dinámico activado',
  'Dynamic Controller is Deactivated': 'Controlador dinámico desactivado',
  'Dynamic Controller is Disabled - Under Maintenance': 'El controlador dinámico está desactivado - En mantenimiento',
  'Dynamic Controller is Disabled by Local Control Switch':
    'El controlador dinámico está desactivado por el interruptor de control local',
  'Dynamic Controller is Disabled by Cloud Control Switch':
    'El controlador dinámico está desactivado por el interruptor de control de la nube',
  leakMeasurementNear: 'Medición de fugas en una semana',
  leakMeasurementOnGoing: 'Medición de fugas en curso',
  leakMeasurementInDays: 'Medición de fugas programada en {{count}} días',
  'Are you sure?': '¿Está seguro?',
  FailedToActivateDynamicController: 'Error al activar el controlador dinámico',
  FailedToDeactivateDynamicController: 'Error al desactivar el controlador dinámico',
  CompressorInMaintenancePreventsActivation:
    'El controlador dinámico no se puede activar debido a que los compresores están en estado de mantenimiento o configurados como prioridad Ignorado',

  // No Flow Control Notification Modal
  noFlowControlNotificationTitle: 'El Control Dinámico para esta estación ha sido actualizado.',
  noFlowControlNotificationSubtitle:
    'Ahora estamos usando flujo estimado ("sin flujo") en lugar del control de sensor de flujo. Como resultado:',
  noFlowControlKpisRecalculated:
    'Los KPIs de Flujo y Potencia Específica se recalculan, por lo que los valores pueden cambiar.',
  noFlowControlSavingsAdjusted: 'Los ahorros se ajustan utilizando la misma potencia específica base.',
  noFlowControlSensorsDifferent:
    'Los sensores de flujo siguen mostrando lecturas, pero ya no afectan los KPIs y aparecen de manera diferente en el mapa.',
  noFlowControlHistoricalKpis: 'Los KPIs históricos del sensor de flujo permanecen disponibles hasta el cambio.',
  noFlowControlClosingMessage:
    'Esta actualización ayuda a asegurar un control suave y un rendimiento constante. ¡Disfrute la actualización!',
  noFlowControlOkButton: '¡OK, entendido!',

  'Last commands': 'Últimos comandos',
  Device: 'Dispositivo',
  'New Value': 'Nuevo valor',
  User: 'Usuario',
  Status: 'Estado ',
  Reason: 'Razón',
  'Date Created': 'Fecha de creación',
  'No commands to show': 'No hay comandos para mostrar',
  'Load more': 'Cargar más',
  'Waiting For Deliver': 'En espera de entrega',
  'Received And Updated': 'Recibido y actualizado',
  'Failed To Update': 'Error en la actualización',
  'Failed TimeOut': 'Error de tiempo de espera',
  'Failed Offline': 'Error de conexión',
  'Ignored Unchanged Value': 'Valor no modificado ignorado',

  //Investigation dashboard
  'Investigate by Devices': 'Investigar por dispositivos',
  'Show me (from-to)': 'Mostrar (de-a)',
  'Compare with (Show me from-to)': 'Comparar con (Mostrar de-a)',
  'You can choose up to 10 parameters per time period. When comparing 2 time periods, you can choose up to 5 parameters.':
    'Puede elegir hasta 10 parámetros por periodo de tiempo. Al comparar 2 periodos de tiempo, puede elegir hasta 5 parámetros.',
  'When comparing 2 time periods, you can choose up to 5 parameters.':
    'Al comparar 2 periodos de tiempo, puede elegir hasta 5 parámetros.',
  'Choose only Power parameters to view the Stack layout. You cannot choose the station total power':
    'Elija sólo parámetros de Potencia para ver la disposición de la Pila. No puede elegir la potencia total de la estación',
  'Station KPIs': 'KPI de la estación',
  'Periods compare': 'Comparación de periodos',
  'Pressure drop': 'Caída de presión',
  'Please choose a time period and at least one parameter.': 'Elija un periodo de tiempo y al menos un parámetro.',
  'No data to show for this time frame and parameters.':
    'No hay datos que mostrar para este periodo de tiempo y parámetros.',
  'Please choose at least one graph.': 'Por favor, elija al menos un gráfico.',
  'Left mouse to zoom': 'Ratón izquierdo para ampliar',
  'Alt + Left mouse to pan': 'Alt + botón izquierdo del ratón para ampliar',
  minuteAverageWithCount: 'Promedio de {{count}} minuto',
  minuteAverageWithCount_plural: 'Promedio de {{count}} minutos',
  hourAverageWithCount: 'Promedio de {{count}} hora',
  hourAverageWithCount_plural: 'Promedio de {{count}} horas',
  'Sensor based': 'Basado en sensor',
  'Comp. Est.': 'Comp. Est.',
  'kW Calc. Based': 'kW Calc. Basado en',
  'AI Calc.': 'Cálc. de IA',
  'kW based calculation': 'Cálculo basado en kW',
  Tabular: 'Tabular',
  'Alerts Record List': 'Lista de registros de alertas',
  'Alert Record': 'Registro de alertas',
  Source: 'Fuente',
  'Date Fired': 'Fecha de disparo',
  'Displayed alerts': 'Alertas visualizadas',
  Archived: 'Archivado',
  'Time period': 'Periodo de tiempo',
  restAlerts: '...y {{restAlertsCount}} alertas más',
  total: 'Total',
  compareTwoTimePeriods: 'Comparar 2 periodos de tiempo',
  none: 'Ninguno',
  showInDeviceStatus: 'Mostrar en estado del dispositivo',
  maintenance: 'Mantenimiento',
  'n/a': 'N/C',
  devicesStatus: 'Estado de los dispositivos',
  dynamicControl: 'Control dinámico',
  optimize: 'OPTIMIZAR',
  now: 'Ahora',

  //Data export
  'Report export': 'Exportación de informes',
  'Report export preferences': 'Preferencias de exportación de informes',
  'This file will be downloaded as a .csv': 'Este archivo se descargará como .csv',
  'Time presentation interval': 'Intervalo de presentación del tiempo',
  'Time zone': 'Zona horaria',
  'Unit system': 'Sistema de unidades',
  Export: 'Exportar',
  'Report contains to many records': 'El informe contiene demasiados registros',
  'Another export is already in progress': 'Ya hay otra exportación en curso',
  VS: 'VS',
  'Data export failed': 'Error en la exportación de datos',
  'While your file is being prepared do not refresh or close this tab':
    'Mientras se prepara el archivo no actualice ni cierre esta pestaña',
  'Something went wrong. Make sure you generated a valid report in the investigation tab':
    'Algo ha salido mal. Asegúrese de haber generado un informe válido en la pestaña de investigación',

  //Station control center
  'Station Control Center': 'Centro de control de la estación',
  TARGET: 'OBJETIVO',
  MAINTENANCE: 'MANTENIMIENTO',
  OPERATION: 'OPERACIÓN',
  'Failed changing maintenance mode': 'Error al cambiar de modo de mantenimiento',
  SCC: 'SCC',
  'You are about to modify the control of the dynamic controller. Are you sure?':
    'Está a punto de modificar el control del controlador dinámico. ¿Está seguro?',
  setpointsSetTo: 'Los puntos de ajuste se configurarán a: ',
  noneSetpoints: 'Puntos de ajuste configurados por última vez',
  baselineSetpoints: 'Puntos de ajuste básicos',
  customSetpoints: 'Puntos de ajuste personalizados ',
  contactCustomerSuccessManager:
    'Póngase en contacto con su Administrador de éxito del cliente para cambiar este comportamiento',

  /// Power toggle tooltips
  'Changes can be made in Station Control Center only.':
    'Los cambios sólo pueden realizarse en el Centro de control de la estación.',
  'Turn compressor on verification': 'Está a punto de encender {{name}}. ¿Está seguro?',
  'Turn compressor off verification': 'Está a punto de apagar {{name}}. ¿Está seguro?',
  'Function is disabled since Engine Mode is Activated':
    'La función está desactivada porque el modo motor está activado.',
  'Function is disabled since changing power state is not supported on this compressor.':
    'La función está desactivada ya que el cambio de estado del motor no está soportado en este compresor.',
  'Waiting for state to change.': 'Esperando a que cambie el estado.',
  'You are not allowed to change power state for devices.':
    'No se le permite cambiar el estado de potencia de los dispositivos.',
  'Are you sure you want to mark this device as In maintenance?':
    '¿Está seguro de que desea marcar este dispositivo como En mantenimiento?',
  'Are you sure you want to mark this device as not in maintenance?':
    '¿Está seguro de que desea marcar este dispositivo como No en mantenimiento?',
  goingToMaintenanceMessage:
    'Configurar todos los compresores en mantenimiento desactivará el control dinámico. ¿Está seguro?',
  CHANGE_COMPRESSOR_STATE_FAILED: 'Error al cambiar el estado de potencia {{deviceName}} del compresor',
  Start: 'Iniciar',
  Stop: 'Parada',

  //P&ID Draft
  'P&ID Draft': 'Borrador P&ID',
  'Last updated on:': 'Última actualización el:',
  'Refresh Map': 'Actualizar mapa',
  'Station Draft': 'Borrador de estación',

  //Value Dashboard
  SHOWING_CURRENT_MONTH_ACCUMULATED_DATA: 'Muestra los datos acumulados del mes en curso',
  Energy: 'Energía',
  Volume: 'Volumen',
  'Energy Efficiency': 'Eficiencia energética',
  'Energy Saving': 'Ahorro de energía',
  Baseline: 'Línea de base',
  'Actual Energy': 'Energía real',
  'Specific Power Baseline': 'Potencia específica de referencia',
  'Maintenance Event': 'Evento de mantenimiento',
  'Baseline Period From': 'Período de referencia del',
  To: 'al',
  DAY: 'DÍA',
  MTD: 'Del mes hasta la fecha',
  YTD: 'Del año hasta la fecha',
  YEAR: 'AÑO',
  MONTH: 'MES',
  AVG: 'PROMEDIO',
  MT: 'TOTAL MENSUAL',
  GHG: 'GHG',
  energySavingsOpportunity: 'Oportunidad de ahorro de energía',
  'MONTH AVG': 'PROMEDIO MENSUAL',
  'YEAR TOTAL': 'TOTAL ANUAL',
  '5-YEAR PROJECTION REDUCTION': 'REDUCCIÓN DE LA PROYECCIÓN A 5 AÑOS',
  // Leakage
  leakage: 'Fuga',
  overview: 'Visión general',
  segmentation: 'Segmentación',
  timeline: 'Cronología',
  // Overview tab
  lastLeakageMeasure: 'ÚLTIMA MEDICIÓN DE FUGA',
  previous: 'Anterior',
  lifetime: 'ACCIÓN',
  lifeTimeLocalization: 'Acción',
  actionTaken: 'Tomada de Por Vida',
  wasted: 'Desperdiciado',
  lastMeasureDate: 'Última medición de fuga',
  nextPeriodicShutdown: 'Próximo cierre',
  add: 'Añadir',
  setAnAudit: 'Establecer un período de auditoría',
  dailyFlowTooltip: 'Flujo promedio diario del mes anterior',
  kwLeakRateSliderTooltip: 'Consumo de energía estimado en la última parada periódica',
  ytdTooltip: 'Los datos se actualizan mensualmente',
  ok: 'OK',
  clear: 'Eliminar',
  nextPeriodicShutdownPopconfirm1:
    'Se ha creado un borrador del periodo de fuga. Solo se mostrará aquí después de que el especialista de Ecoplant lo apruebe.',
  nextPeriodicShutdownPopconfirm2:
    'Asegúrese de que los compresores se mantengan encendidos durante al menos 2 horas para que el sistema capte las posibles fugas.',
  startEnd: 'Inicio - Fin',
  productionLeakRate: 'Tasa de fuga prod',
  addNextPeriodicShutdown: 'Añadir borrador del siguiente periodo de fuga',
  confirmDeleting: 'Borrar cierre de periodo para periodos {{period}}',
  delete: 'Borrar',
  excludeFuturePeriodicShutdowns: 'Excluir futuros periodos de cierre',
  leakFlow: 'Fuga',
  estimatedLeakTooltip: 'Fuga estimada ({{estimatedLeak}}',
  sampledFlowDuringShutdownTooltip: 'Flujo de muestreo durante la parada ({{sampledFlowDuringShutdown}}',
  productionLeakRateTooltip:
    'Calculado normalizando el flujo de fuga a la presión objetivo y dividiendo por el flujo promedio de producción ({{productionLeakRate}}',
  overlappingDates: 'Las fechas superpuestas no son válidas',
  updateLeakAudit: 'Actualizar auditoría de fugas',
  updateAudit: 'Actualizar auditoría',
  leakAuditUpdatedSuccessfully: 'Auditoría de fugas actualizada correctamente',
  theAuditDatesHaveBeenUpdated: 'Las fechas de la auditoría han sido actualizadas',
  leakAuditUpdatedAndPublishedSuccessfully: 'El borrador de fuga ha sido publicado al cliente',
  errorUpdatingLeakAudit: 'Error al actualizar la auditoría de fugas',
  leakAuditRejectedSuccessfully: 'Auditoría de fugas rechazada correctamente',
  errorRejectingLeakAudit: 'Error al rechazar la auditoría de fugas',
  leakAuditBookedSuccessfully: 'Auditoría de fugas reservada correctamente',
  scheduleLeakAudit: 'Programar auditoría de fugas',
  setAudit: 'Establecer auditoría',
  reviewLeakAudit: 'Revisar auditoría de fugas',
  rejectAudit: 'Rechazar auditoría',
  updateAndPublish: 'Actualizar y publicar',
  viewLeak: 'Ver fuga',
  // MeasurementSegmentation tab
  totalWasteFlow: 'Flujo total de residuos',
  totalProductionFlow: 'Flujo total de producción',
  productionLine: '{{productionLineName}} Línea',
  totalPlant: 'Total de planta',
  production: 'Producción',
  waste: 'Residuos',
  flowLabel: 'Flujo',
  effective: 'Eficaz',

  // Insights
  insights: 'Perspectivas',
  events: 'Eventos',
  // Overview tab
  ytdValue: 'VALOR DEL AÑO HASTA LA FECHA',
  lifetimeValue: 'VALOR DE POR VIDA',
  savingsOpportunity: 'OPORTUNIDAD DE AHORRO',
  saved: 'AHORRADO',
  actionsPending: 'Acciones pendientes',
  actionsTaken: 'Acciones tomadas',
  rejected: 'rechazadas',
  Risk: 'Riesgo',
  // Events tab
  pendingTasksOnly: 'Sólo tareas pendientes',
  dateOpened: 'Fecha de apertura',
  insightName: 'Nombre de percepción',
  asset: 'Activo',
  valueType: 'Tipo de valor',
  value: 'Valor {{currency}}',
  dateCompleted: 'Fecha de finalización',
  InProgress: 'En curso',
  Reject: 'Rechazado',
  estimatedDeliveredValue: 'Valor estimado de entrega',

  // Engine
  wizard: 'Asistente',
  draft: 'Borrador',
  newDraft: 'Nuevo borrador',
  createNewDraft: 'Crear un nuevo borrador',
  published: 'Publicado',
  recommended: 'Recomendado',
  publishDraftConfirmation:
    '¿Está seguro de que desea publicar todos los cambios realizados en todas las pestañas de configuración?',
  publishRecommendationConfirmation:
    'Esta versión se publicará directamente en producción {{draftVersionText}}. ¿Desea continuar?',
  draftVersionText: ' y anular la versión de borrador existente {{draftVersion}}  ',
  newRecommendedConfiguration: ' Existe una nueva versión del controlador dinámico. Fecha de creación: {{createdDate}}',
  'publishConfirmationEngine1.0':
    'Esta estación está administrada por el Controlador Dinámico versión 1.0. Para actualizar la versión 1.5, vaya a ReTool y cambie la versión del motor a 1.5. Una vez que haya hecho esto, esta versión publicada administrará la estación.',
  revertToPublishedConfirmation:
    ' ¿Está seguro de que desea anular las configuraciones con los que están publicados actualmente? ',
  missingMandatoryFieldValue:
    'El campo editable = "{{field}}" del compresor = "{{compressor}}" de la tabla = "{{table}}" requiere una entrada válida.',
  recommendationFlowLevelsChanged:
    'Se han modificado los niveles de flujo o los rangos de presión, por lo tanto, las reglas de respaldo existentes ya no son válidas y se han eliminado.',
  revertToPublished: 'Volver a Publicado',
  publish: 'Publicar',
  settings: 'Ajustes',
  next: 'Siguiente',
  back: 'Atrás',
  finish: 'Finalizar',
  cancel: 'Cancelar',
  defaults: 'Valores predeterminados',
  noDynamicController: 'No se ha definido el controlador dinámico.',
  // Recommendation
  createdOn: 'CrearCreado en: ',
  approvalReport: 'Informe de aprobación',
  // Rules Generator
  mainRanges: 'Rangos principales',
  mainRangesConfiguration: 'Configuración de flujo y presión',
  rulesGenerator: 'Generador de reglas',
  flowLevels: 'NIVELES DE FLUJO',
  'Flow Levels': 'Niveles de flujo',
  pressureLevels: 'RANGOS DE PRESIÓN',
  result: 'RESULTADO',
  rules: 'Reglas',
  // Flow Levels
  units: 'Unidades',
  name: 'Nombre',
  lowerBoundFlow: 'Flujo límite inferior',
  upperBoundFlow: 'Flujo límite superior',
  addRangeName: ' Añadir nombre de rango',
  addUpperRange: 'Añadir rango superior',
  addLevel: 'Añadir nivel',
  addPressureRange: 'Añadir rango de presión',
  infinity: 'Infinito',
  flowLevelsChanged:
    'Se modifican los rangos de valores de los sensores, cambie los valores de las reglas de la tabla según corresponda y guarde los últimos valores',
  changesInMainRangesAffectFallbackRules:
    'Los cambios en los rangos principales provocaron cambios en las reglas alternativas. ¿Está seguro de que desea continuar?',
  // Pressure Levels
  range: 'Rango',
  id: 'Id',
  lowerBoundPressure: 'Presión límite inferior',
  upperBoundPressure: 'Presión límite superior',
  thisPressureLevel: 'este nivel de presión',
  // Result
  mainRangesResult: 'RESULTADO',
  flowLevel: 'Nivel de flujo',
  rule: 'Regla',
  // Sensors
  sensors: 'Sensores',
  sensorsSelection: 'Configuración de KPI',
  sensorsConfiguration: 'Configuración de sensores',
  flowSensorsPriority: 'SELECCIÓN DE SENSORES DE FLUJO',
  pressureSensorsPriority: 'SELECCIÓN DE SENSORES DE PRESIÓN',
  sensorsPriorityResult: 'RESULTADO',
  main: 'Principal',
  fallback: 'Alternativa {{priority}}',
  fallbacks: 'Alternativas',
  logic: 'Lógica',
  online: 'En línea',
  any: 'Cualquiera',
  all: 'Todas',
  average: 'Promedio',
  minimum: 'Mínimo',
  maximum: 'Máximo',
  sum: 'Suma',
  addFallback: 'Añadir alternativa',
  defaultBehaviour: 'Comportamiento predeterminado',
  chooseRule: 'Elegir regla',
  customRule: 'Regla personalizada',
  turnOffEngine: 'Apagar motor',
  ruleGenerator: 'Generador de reglas',
  newRuleName: 'NOMBRE DE LA NUEVA REGLA',
  // Result
  flowSensorsSelection: 'Selección de sensores de flujo',
  pressureSensorsSelection: 'Selección de sensores de presión',
  // Compressors
  compressors: 'Compresores',
  compressorGroups: 'Grupos de compresores',
  rotation: 'Rotación',
  on: 'Encendido',
  off: 'Apagado',
  repeatEvery: 'Repetir cada',
  repeatOn: 'Repetir en',
  time: 'Tiempo',
  weeks: 'semanas',
  addCompressorGroup: 'Añadir un nuevo grupo de compresores',
  deletePopconfirmTitle: 'Está a punto de eliminar {{item}}. ¿Está seguro?',
  // Default Rule
  defaultRule: 'Regla predeterminada',
  defaultSetpoints: 'Valores predeterminados de la tabla',
  defaultSetpointsConfiguration: 'Valores predeterminados de la tabla',
  groupAndPriority: 'Grupo | Prioridad',
  order: 'Orden',
  load: 'Carga',
  unload: 'Descarga',
  autoStop: 'Parada automática',
  immediateStop: 'Parada inmediata',
  pressureDrop: 'Caída de presión',
  vsdTarget: 'Objetivo',
  modulate: 'Modular',
  bandConfiguration: 'Configuración de banda',
  defaultSetpointsInfoMessage:
    'Los puntos de ajuste se basan en las lecturas de presión de la línea del compresor (tenga en cuenta las caídas de presión)',
  setpointsLoadUnloadValidation: 'El punto de ajuste de Descarga debe ser mayor que el punto de ajuste de Carga.',
  pidChanges: `A new engine strategy must be defined and published since the station P&ID has changed.
Below is the list of assets  that affect the control strategy:`,
  compressorsAdded: 'Compresores añadidos:',
  compressorsRemoved: 'Compresores eliminados:',
  flowKPIModified: 'KPI de flujo modificado:',
  pressureKPIModified: 'KPI de presión modificado:',
  compressorPriorityChangedToIgnore: 'La prioridad del compresor cambió de (Activo/Respaldo) a Ignorar:',
  compressorPriorityChangedFromIgnore: 'La prioridad del compresor cambió de Ignorar a (Activo/Respaldo):',

  // Station Parameters
  stationParameters: 'Parámetros de la estación',
  compressorParameters: 'Parámetros del compresor',

  //package care
  careAgrremntID: 'ID del acuerdo',
  annugalHoursCoverage: 'Cobertura anual de horas ',
  startDate: 'Fecha de inicio',
  expirationDate: 'Fecha de vencimiento',
  packageCare: 'PackageCARE',
  packageCareStatus: 'Estado de PackageCARE',
  inactive: 'Inactivo',
  invalidDate: 'Fecha no válida',
  package: 'Paquete',
  planned: 'Planificado',
  parts: 'Piezas',
  care: 'CARE',
  careServiceSignUp: 'Inscríbase en el plan de servicio CARE',
  noCareProgram: 'Ningún programa Care',
  thankInterestCare: '¡Gracias por su interés en CARE!  ',
  noCarePlan: 'Ningún plan CARE',
  activeAsset: 'está activado para este activo',
  tm: 'TM',
  // Fallback Scenarios
  fallbackScenarios: 'ESCENARIOS DE ALTERNATIVAS',
  addScenario: 'Añadir escenario',
  onFailureOf: 'En caso de fallo de',
  singleRuleForAllFlowLevels: 'Regla única para todos los niveles de flujo',
  logicPerFlowLevel: 'Lógica por nivel de flujo',
  // Validations
  flowRanges: 'Rangos de flujo',
  pressureRanges: 'Rangos de presión',
  rangesAreMandatory: '$t({{ranges}}) son obligatorios',
  compressorsAreMandatory: 'Compresores obligatorios',
  higherUpperBound: 'Debe ser mayor que el Límite Superior anterior',
  mustBeEqualOrHigherThan1: 'Debe ser igual o mayor que 1',
  compressorsCombinationMustBeUnique: 'La combinación de compresores debe ser única',
  compressorIsNotCompatibleToGroup: 'Todos los compresores añadidos a grupos deben tener las mismas acciones',
  compressorsMustHaveSameHp: 'Los compresores deben tener la misma potencia HP',
  oneFallbackOptionShouldBeSelected: 'Debe seleccionarse una opción alternativa',
  oneRuleShouldBeSelected: 'Debe seleccionarse una regla',
  sensorsAreMandatory: 'Los sensores son obligatorios',
  sensorFlowCombinationMustBeUnique: 'La combinación de configuración de flujo de sensores debe ser única',
  // Rules
  rulesOverview: 'Reglas',
  rulesEditor: 'Editor de reglas',
  // Rules Overview
  no: 'No',
  ord: 'ORD',
  lo: 'LO',
  un: 'UN',
  target: 'TRG',
  mod: 'MOD',
  aut: 'AUT',
  imm: 'IMM',
  pd: 'PD',
  bnd: 'BND',

  // new fallback columns
  compressorNumber: 'Número de compresor',
  titleOrder: 'ORD',
  titleLoad: 'LO',
  titleUnload: 'UN',
  titleTarget: 'TRG',
  titleModulate: 'MOD',
  titleAutoStop: 'AUT',
  titleImmediateStop: 'IMM',
  titlePressureDrop: 'PD',
  titleBandConfiguration: 'BND',
  // Rules Editor
  standalone: 'Independiente',
  viewMode: 'Modo de visualización',
  editMode: 'Modo de edición',
  save: 'Guardar',
  discard: 'Sí (descartar)',
  keepEditing: 'No (seguir editando)',
  // Fallback Overview
  fallbackOverview: 'Alternativa',
  sensorsLogic: 'Lógica de los sensores',
  compressorsGroupOrder: 'Orden del grupo de compresores',
  compressorsFallback: 'Alternativa de compresores',
  flowSensorsFallback: 'Alternativa de sensores de flujo',
  pressureSensorsFallback: 'Alternativa de sensores de presión',
  sensorPriorityInfoMessage: 'En caso de fallo, se ejecutará la siguiente lógica',
  editScenarios: 'Editar escenarios',
  // Version History
  versionHistory: 'Historial de versiones',
  lastUpdated: 'Última actualización',
  version: 'Versión',
  changes: 'Cambios',
  revertPublishedVersion:
    'Al volver a la versión anterior, se publicará una nueva estrategia que anulará el borrador existente. ¿Desea continuar?',
  actions: 'Acciones',
  recommendation: 'Recomendado',
  algo: 'Algo',
  manual: 'Manual',

  // station risk
  Low: 'Bajo',
  Moderate: 'Moderado',
  High: 'Alto',
  SYSTEM_AVAILABILITY: 'disponibilidad del sistema',
  REALTIME_SYSTEM_CAPACITY: 'capacidad del sistema en tiempo real',
  'System Health': 'Salud del sistema',
  'System Degradation': 'Degradación del sistema',
  'System Single Point of Failure Risk': 'Riesgo de punto único de fallo del sistema',
  'Available flow subtitle': 'Disponible',
  'Peak production subtitle': 'Producción máxima',
  'Month Over Month avg Flow Trend': 'Tendencia mensual del flujo promedio',
  'peak production delta increase part1': 'Su producción de aire comprimido mes a mes ha aumentado en ',
  'peak production delta increase part2':
    ' reflejando un crecimiento en la producción o un posible aumento de la fuga en el crecimiento',
  'available delta decrease part1': 'Su capacidad de producción mes a mes refleja un desempeño disminuido de ',
  'available delta decrease part2': '. Compruebe el mantenimiento y el funcionamiento deficiente de sus compresores.',
  'realtime flow over peak error':
    'Error - El valor en tiempo real {{realtime}}está por encima del flujo máximo {{peakSupplyFlow}}. Póngase en contacto con el servicio técnico de Ecoplant',
  'realtime flow over total flow error':
    'El valor en tiempo real {{realtime}}es superior al flujo total de la estación {{totalFlow}}.',
  'realtime flow over max available flow error':
    'El valor en tiempo real {{realtime}}está por encima del flujo máximo disponible {{totalFlow}}.',
  'Station risk degradation tooltip text':
    'Degradación operativa del sistema y por compresor respecto a su especificación nominal',
  'Realtime Production': 'Producción en tiempo real',
  'Peak Production': 'Producción máxima',
  PEAK_PRODUCTION: 'producción máxima',
  'Avg Production': 'Producción promedio',
  AVG_PRODUCTION: 'producción promedio',
  'Max Available': 'Máx. disponible',
  Degradation: 'Degradación',
  MODERATE_RISK: 'riesgo moderado',
  LOW_RISK: 'riesgo bajo',
  STATION_DEGRADATION: 'degradación de la estación',
  PLANNED_AVAILABILITY: 'disponibilidad prevista',
  CURRENT_YEAR: 'AÑO ACTUAL',
  PREVIOUS_YEAR: 'AÑO ANTERIOR',

  // users management
  'Users Management': 'Administración de usuarios',
  'Manage Users': 'Administrar usuarios',
  'Create new user': 'Crear nuevo usuario',
  'User must be assigned to at least one station': 'El usuario debe estar asignado al menos a una estación',
  'User created successfully': 'Usuario creado correctamente',
  'User creation failed, please contact support for further information':
    'La creación del usuario ha fallado, por favor póngase en contacto con el servicio de asistencia para más información',
  'You are about to delete this user completely. Are you sure?':
    'Está a punto de eliminar completamente este usuario. ¿Está seguro?',
  'Delete user': 'Borrar usuario',
  'Changes will not be saved. Are you sure?': 'Los cambios no se guardarán. ¿Está seguro?',
  'Discard changes': 'Descartar cambios',
  'First name': 'Nombre de pila',
  'Please input your first name': 'Por favor, introduzca su nombre',
  'Last name': 'Apellido',
  'Please input your last name': 'Por favor, introduzca su apellido',
  Email: 'Correo electrónico',
  'Please input your email': 'Introduzca su dirección de correo electrónico',
  'Please input a valid email address': 'Introduzca una dirección de correo electrónico válida',
  'Measurement system': 'Sistema de medición',
  'Please choose your measurement system': 'Seleccione su sistema de medición',
  'Dial code': 'Código de marcado',
  'Please input your dial code': 'Por favor, introduzca su código de marcado',
  Number: 'Número',
  'Please input your number': 'Introduzca su número',
  '9 or 10 digits are allowed': '¡Se permiten 9 o 10 dígitos!',
  'Only numbers are allowed!': 'Sólo se permiten números',
  'Please choose a station': 'Por favor, elija una estación',
  'Please choose a role': 'Por favor, elija un rol',
  'You are about to remove this user’s access to this station. Are you sure?':
    'Está a punto de eliminar el acceso de este usuario a esta estación. ¿Está seguro?',
  'E.g. John': 'P. ej. John',
  'E.g. Doe': 'P. ej. Doe',
  'John@domain.com': 'John@domain.com',
  'Select measurement system': 'Seleccione el sistema de medición',
  '+001': '+001',
  '000000000': '+000000000',
  'Select station': 'Seleccione estación',
  'Select role': 'Seleccione rol',

  // EULA
  'License Agreement': 'Acuerdo de licencia',
  Decline: 'Rechazar',
  Accept: 'Aceptar',

  // Water Temperature
  WATER_TEMPERATURE: 'Temperatura del agua',
  IN: 'Entrada',
  OUT: 'Salida',

  // Metrics
  PRESSURE: 'Presión',
  FLOW: 'Flujo',
  WATER_FLOW: 'Flujo del agua',
  WATER_PRESSURE_IN: 'Presión de entrada de agua',
  WATER_PRESSURE_OUT: 'Presión de salida del agua',
  WATER_PRESSURE_DELTA: 'Presión del agua Delta',
  EST_FLOW: 'est. Flujo',
  POWER: 'Potencia',
  TEMPERATURE: 'Temperatura',
  AIR_TEMPERATURE: 'Temperatura del aire',
  AIR_TEMPERATURE_SENSOR: 'Sensor de temperatura del aire',
  DEW_POINT_TEMPERATURE: 'Temperatura del punto de rocío',
  INLET_WATER_TEMPERATURE: 'Temperatura del agua de entrada',
  OUTLET_WATER_TEMPERATURE: 'Temperatura del agua de salida',
  CURRENT: 'Corriente',
  OIL_TEMPERATURE: 'Temperatura del aceite',
  INVERTER_SPEED: 'Velocidad del inversor',
  RUN_HOURS: 'Horas de funcionamiento',
  LOAD_HOURS: 'Horas de carga',
  HUMIDITY: 'Humedad',
  CONTROL_MODE: 'Modo de control',
  MINIMUM_PRESSURE: 'Presión mínima',
  MAXIMUM_PRESSURE: 'Presión máxima',
  NEXT_SERVICE_HOURS: 'Próximas horas de servicio',
  NEXT_SERVICE_NAME: 'Nombre del próximo servicio',
  ACTIVITY: 'Actividad',
  SPECIFIC_POWER: 'Potencia específica',
  EST_SPECIFIC_POWER: 'est. Potencia específica',
  EST_INVERTER_SPEED: 'est. Velocidad del inversor',
  POWERED_ON: 'Encendido',
  INLET_VALVE_OPENING: 'Apertura de la válvula de entrada',
  BYPASS_VALVE_OPENING: 'Apertura de la válvula de derivación',
  CENTRIFUGAL_TARGET_SETPOINT: 'Punto de ajuste centrífugo',
  OPERATION_MODE: 'Modo de operación',
  DRYER_FILTER_SERVICE_HOURS: 'Horas de servicio del filtro de la secadora',
  DRYER_DESICCANT_SERVICE_HOURS: 'Horas de servicio del desecante de la secadora',
  DRYER_VALVE_SERVICE_HOURS: 'Horas de servicio de la válvula de la secadora',
  DRYER_LEFT_TOWER_ACTIVITY: 'Actividad de la torre izquierda de la secadora',
  DRYER_RIGHT_TOWER_ACTIVITY: 'Actividad de la torre derecha de la secadora',
  DRYER_BLOWER_ACTIVITY: 'Actividad del soplador de la secadora',
  DRYER_HEATER_ACTIVITY: 'Actividad del calentador de la secadora',
  DRYER_TEMPERATURE_SETPOINT_CELSIUS: 'Punto de ajuste de temperatura de la secadora en grados Celsius',
  DRYER_OPERATION_MODE: 'Modo de funcionamiento de la secadora',
  DRYER_EXTENDED_ACTIVITY: 'Actividad extendida de la secadora',
  EXTERIOR_AMBIENT_TEMPERATURE: 'Temperatura ambiente exterior',
  FREQUENCY: 'Frecuencia',
  P_H: 'PH',
  AMMONIA_AMMONIUM: 'Amoníaco (NH3)/Amonio (NH4+)',
  NITRATE_NO_3: 'Nitrato (NO3-)',
  NITRITE_NO_2: 'Nitrito (NO2-)',
  OXIDATION_REDUCTION_POTENTIAL: 'Potencial de reducción del oxígeno',
  DISSOLVED_OXYGEN: 'Oxígeno disuelto',
  BLOWER_SPEED: 'Velocidad del ventilador',
  BLOWER_TARGET_SPEED: 'Velocidad objetivo del soplante',
  INFLUENT_FLOW: 'Flujo afluente',
  SPILL_VALVE_HP_LOW_LIMIT_SETPOINT: 'Punto de ajuste de límite bajo de CV de la válvula de derrame',
  SPILL_VALVE_HIGH_PRESSURE: 'Presión alta de la válvula de derrame',
  SPILL_VALVE_LOW_PRESSURE: 'Presión baja de la válvula de derrame',
  SPILL_VALVE_LP_TARGET_SETPOINT: 'Punto de ajuste objetivo de presión baja de la válvula de derrame',
  CURRENT_VALVE_POSITION: 'Posición de la válvula de corriente',

  COMMAND_WAITING_FOR_DELIVER: 'En espera de entrega',
  COMMAND_RECEIVED_AND_UPDATED: 'Recibido y actualizado',
  COMMAND_FAILED_TO_UPDATE: 'Error en la actualización',
  COMMAND_FAILED_TIME_OUT: 'Error de tiempo de espera',
  COMMAND_FAILED_OFFLINE: 'Error de conexión',
  COMMAND_IGNORED_UNCHANGED_VALUE: 'Valor no modificado ignorado',

  'Ambient Temperature': 'Temperatura ambiente',
  'Ambient Humidity': 'Humedad ambiente',

  'Failed retrieving commands history': 'Error al recuperar el historial de comandos',
  alpha: 'Alfa',
  beta: 'Beta',
  powerUsersOnly: 'Solo usuarios de energía eléctrica',
  allowCookies: 'Permitir cookies',
  decline: 'Rechazar',

  general: 'General',
  true: 'Verdadero',
  false: 'Falso',
  'Clear all engine configurations': 'Borrar todas las configuraciones del motor',
  'Engine ready': 'Motor listo',
  yes: 'Sí',
  'Are you sure you want to delete all data?': '¿Está seguro de que desea borrar todos los datos?',

  energySavingsReportTitle: 'Informe Ecoplant 360',
  energySavingsReportDescription:
    'A continuación se muestra el ahorro de energía impulsado por el Controlador dinámico Ecoplant. ' +
    'Se presenta en diferentes resoluciones de tiempo, día anterior, mes hasta la fecha, año hasta la fecha y ' +
    'ahorro de por vida. Se presenta en (1) Porcentaje (%) (y en kWh) (2) en moneda local (3) Toneladas métricas estimadas ' +
    'de reducción de GEI. Los ahorros se calculan a partir de una comparación con el periodo de referencia y su  energía eléctrica ' +
    'específica capturada (S/P).',

  insightsReportDescriptionOne:
    'Ecoplant 360 proporciona a sus usuarios una visión continua impulsada por nuestro sistema o por nuestros expertos que revisan  ' +
    'el sistema. Estos datos se dividen en tres categorías: energía, mantenimiento y riesgo. Todas las perspectivas tienen ' +
    'una indicación de acción, ya sea acción pendiente o acción tomada. Se muestra el importe estimado en USD correspondiente.',
  insightsReportDescriptionTwo:
    'Para cualquier acción pendiente, haga clic en la información correspondiente para conocer las acciones necesarias. Para cualquier aclaración ' +
    'y detalles técnicos por favor póngase en contacto con su administrador de éxito del cliente.',
  insightsReportDescriptionThree:
    ' La suscripción a la información en tiempo real puede completarse en el tablero de Ecoplant 360',

  leakageReportDescription:
    'Ecoplant 360 proporciona a sus usuarios una visión general de la fuga estimada. ' +
    'Para garantizar una lectura actualizada de las fugas, añada en el panel de valores su próxima parada de producción prevista. ' +
    'Durante el periodo de parada y con el fin de medir las fugas, el compresor se mantendrá en funcionamiento durante un par de ' +
    'horas para que el sistema pueda medir el consumo por fugas del sistema.',

  measuredLeak: 'Medido',
  leakMeasureFlow: '% Flujo',
  leakProductionFlow: '% prod. flujo',
  leakageCreatedNotificationMessage: 'Avisa cuando se crea un nuevo evento de fuga',

  openInsightsReportDescriptionOne:
    'A continuación se muestra una lista de todas las perspectivas abiertas en la que figuran tanto los puntos de acción pendientes como los puntos en curso.',
  openInsightsReportDescriptionTwo:
    'Para más explicaciones y análisis, póngase en contacto con su representante de atención al cliente.',
  openInsightsReportFooterText: 'En el tablero de valores de Ecoplant 360, podrá explorar detalles adicionales.',

  //LIGHT Project
  enableSystemControl: 'Se calcula Habilitar',
  isCalculated: 'control del sistema {{metric}}.',
  FlowUpper: 'Flujo',
  PowerUpper: 'Potencia',
  toRecord: ' Para registrar su sistema {{field}} con precisión,  ',
  performance: 'rendimiento',
  AddNewCompressor: 'Añada un nuevo compresor',
  performanceKpisCalculated: 'Se calculan los KPI de rendimiento.',
  learnMoreIncreaseSavingsNum:
    'Obtenga más información y aumente el ahorro con #{{num}} información adicional sobre el sistema ',
  learnMoreIncreaseSavings: 'Obtenga más información y aumente el ahorro con información adicional sobre el sistema',
  learnMoreRecord: 'Obtenga más información y registre su rendimiento con precisión',
  clickHere: 'Haga clic aquí',
  expandYourStation: 'Amplíe su estación y obtenga una visión general de todos los componentes pertinentes',
  addCompressor: 'Para añadir un compresor, ',
  Integration: 'Integración',
  externalDeviceId: 'Id. externa',
  startIntegrationProcess: ' e inicie el proceso de integración ',
  getSensorPackage: ' y obtenga el paquete de sensores adecuado.',
  toRecordPerformance: '  Para registrar su rendimiento con precisión ',
  alwaysPerform: ' y trabajar siempre en el modo de funcionamiento óptimo gracias al control automático del sistema',
  calculatedValues: 'Valores calculados',
  learnMoreAndEnableSystemControl: 'Más información y activación del control del sistema',
  learnMoreAndEnableKPIs:
    'Más información y activación de KNOW - SYSTEM para obtener sus KPI de rendimiento individuales',
  learnMoreAndEnableLeakage: 'Más información y activación de fugas',
  energySavingsSystemTierTooltipPart1:
    'Oportunidades de ahorro de energía esperadas basadas en estudios de casos reales. Para trabajar siempre en un modo de funcionamiento óptimo y obtener estos ahorros, ',
  energySavingsSystemTierTooltipPart2: ' y añada Control del sistema.',
  requestTierConfirmationMessageLine1: 'Se envía un mensaje a Ecoplant.',
  requestTierConfirmationMessageLine2: 'Nos pondremos en contacto con usted inmediatamente',
  backgroundDataYearlyView: 'Los datos de referencia son ejemplos del balance energético anual, incluido el ahorro.',
  backgroundDataLeakage: 'Los datos de referencia son ejemplos del widget de fugas.',
  additionalSensors: 'Sensores adicionales',
  addPressureSensorPack:
    ' y añada un paquete de sensores de presión para acceder a las condiciones de presión y fugas del sistema',
  addStationKpis: ' y obtenga los KPI completos de su estación. Haga clic aquí y active la vista del sistema',
  addIndividualSensors: ' y añada sensores individuales para acceder a las condiciones de funcionamiento de su sistema',
  system: 'Sistema',
  flowIsCalculated: 'Se calcula el flujo',
  learnMoreAndEnableSystemHealth: 'Más información y activación de la salud del sistema',
  lockedFunctionality: 'Funcionalidad bloqueada',
  backgroundDataSystemHealth: 'Los datos de referencia son ejemplos del balance energético anual, incluido el ahorro.',
  systemView: 'KNOW - SYSTEM',
  systemViewDescription:
    'Desbloquee una supervisión exhaustiva del rendimiento de su sistema a través de un mapa P&ID individual, tendencias del sistema, monitorización de riesgos del sistema y perspectivas adicionales del sistema para mejorar el rendimiento y la salud de su sistema en general.',
  learnMoreAndWatchVideo: 'Más información y ver vídeo',
  assetCount: '{{assetCount}} Compresores',
  mon: 'mensual',
  perAsset: 'por compresor',
  billedAnnually: 'Facturación anual o  ',
  monthly: ' mensual',
  expectedAnnualSavings: 'Ahorro anual esperado',
  expectedROI: 'ROI esperado',
  years: '< {{years}} Años',
  startOneMonthTrial: ' Iniciar un mes de prueba',
  orPurchaseNow: 'o compre ahora',
  allAssetViewFeatures: 'Todas las características de KNOW - ASSET, y además:',
  individual: 'Mapa P&ID',
  pidMap: 'individual',
  monitorAndSupervise:
    'para monitorizar y supervisar el rendimiento de todo su sistema e identificar al instante los componentes críticos.',
  systemHealthStatus: 'Estado de salud del sistema',
  isPartOf:
    'forma parte del tablero de valores, que monitoriza su sistema y el nivel de riesgo de producción en tiempo real.',
  systemInsights: 'La información del sistema',
  improveSystemPerformance:
    'sobre Energía, mantenimiento y riesgo mejoran el rendimiento y la salud del sistema y reducen los costes de explotación.',
  derivedSystemEfficiencyParameters: 'Parámetros derivados de la eficiencia del sistema',
  suchAs: 'como la presión, el flujo, la potencia y la potencia específica del sistema;',
  systemTrends: 'Tendencias del sistema',
  toAnalyzeAndOptimize: ' para analizar y optimizar el rendimiento del sistema basándose en datos históricos.',
  backgroundDataMap: 'El P&ID de referencia representa un ejemplo del mapa del sistema. ',
  backgroundData: 'Los datos de referencia son ejemplos',
  simpleControlDescription:
    'Con el sencillo motor de control mejorará la eficiencia global y la utilización de su sistema y reducirá el tiempo de funcionamiento de los compresores de reserva y de alquiler.  Esto le ayuda a reducir considerablemente los costes energéticos de su sistema.',
  dynamicControlDescription:
    'Desbloquee el motor de control dinámico completo para analizar y ajustar automáticamente el funcionamiento a las necesidades de producción y obtener la máxima eficacia del sistema. Asimismo, puede detectar y aislar las fugas de aire para mejorar aún más la eficiencia y reducir al mínimo sus costes energéticos totales.',
  simpleControl: 'CONTROL',
  allSystemViewFeatures: 'Todas las características de KNOW - SYSTEM, y además:',
  simpleControlEngine: 'Motor de control simple',
  toContinouslyOptimize: 'para optimizar continuamente la eficiencia del sistema y la utilización del compresor',
  energySavingsWidget: 'Widget de ahorro energético',
  toProvideComprehensiveOverview:
    'para proporcionar una visión global del ahorro total de energía (por día, mes, año &amp; total) basado en la eficiencia optimizada del sistema frente a su funcionamiento inicial',
  greenhouseGasEmission: 'Emisiones de gases de efecto invernadero',
  savingsBasedOn: 'basadas en la eficiencia optimizada del sistema',
  allSimpleControlFeatures: 'Todas las funciones de CONTROL, y además:',
  dynamicControlEngine: 'Motor de control dinámico',
  predictiveAlgorithms:
    'Los algoritmos predictivos evalúan su consumo energético diario, semanal y estacional, controlando dinámicamente los sistemas mediante perfiles de producción para minimizar el desperdicio de energía, la redundancia y el exceso de costes de los servicios públicos.',
  leakageWidget: 'Widget de fugas',
  forDetectingAndIsolating:
    'para detectar y aislar las ubicaciones de las fugas reduce significativamente sus pérdidas de energía.',
  continuousAutiding: 'Auditoría continua ',
  reviewYourSystemPerformance: 'Revise el rendimiento y el nivel de salud de su sistema',
  getYourPrice: 'Obtenga su precio',
  systemControl: 'Control del sistema',
  learnMoreAndRequestTrial: 'MÁS INFORMACIÓN Y SOLICITUD DE PRUEBA',
  ecoplantOffering: 'Oferta de Ecoplant',
  addOns: 'Complementos',
  yourCurrentVersion: 'Su versión actual',
  noStationsAvailable: 'No hay estaciones disponibles',
  language: 'Idioma',
  selectLanguage: 'Seleccione idioma',
  english: 'Inglés',
  french: 'Francés',
  german: 'Alemán',
  Station: 'Estación',
  Role: 'Función',
  SMS: 'SMS',
  Insight: 'Perspectiva',
  Weekly: 'Semanal',
  Monthly: 'Mensual',
  Avg: 'Promedio',
  kWh: 'kWh',
  leakMeasurement: 'Medición de fugas',
  valueDashboard: 'Tablero de valores',
  userName: 'Nombre de usuario',
  phoneNumber: 'Número de teléfono',
  'MT GHG': 'MT GEI',
  forMoreThan: 'para más de',
  userAssociatedStations: 'Estaciones asociadas al usuario',
  'Min / Max': 'Mín / Máx',
  simulationValue: '(Valor de simulación)',
  actualValue: '(Valor de real)',
  Operation: 'Operación',
  Unselect: 'Deseleccionar',
  'Manufacturer and Custom Alerts with Shutdown Severity':
    'Alertas de fabricante y personalizadas con gravedad de parada',
  'Manufacturer and Custom Alerts with Warning Severity':
    'Alertas de fabricante y personalizadas con gravedad de advertencia',
  'Manufacturer and Custom Alerts with Service Severity':
    'Alertas de fabricante y personalizadas con gravedad de servicio',
  'Notifies on Periodic Shutdown event creation, 1 day before the event':
    'Notifica cuando se crea un evento de Apagado periódico, 1 día antes del evento',
  'Notifies when a new Insight Event is created': 'Notifica cuando se crea un nuevo Evento de perspectiva',
  'Notifies when the Dynamic Controller is turned On or Off':
    'Notifica cuando el controlador dinámico se enciende o se apaga',
  "Notifies when a Device's Maintenance flag is changed":
    'Notifica cuando se cambia el indicador de mantenimiento de un dispositivo',
  'Notifies when a Report is generated': 'Notifica cuando se genera un informe',
  'Notifies when a Station is switched On or Off': 'Notifica el encendido o apagado de una estación',
  "couldn't fetch data": 'No se pueden obtener datos',
  'User update failed': 'Error de actualización de usuario',
  'User deletion failed': 'Error en la eliminación de usuario',
  'User updated successfully': 'Usuario actualizado correctamente',
  'User deleted successfully': 'Usuario eliminado correctamente',
  Refresh: 'Actualizar',
  'Activity Log': 'Registro de actividad',
  Compressors: 'Compresores',
  'Learn More And Enable Leakage': 'Más información y activación de la fuga de datos',
  'Background Data Leakage': 'Fuga de datos de fondo',
  'Sign in': 'Iniciar sesión',
  OR: 'O',
  'Login with SSO': 'Iniciar sesión con SSO',
  'is Activated': 'está activado',
  'is Deactivated': 'está desactivado',
  'is Disabled - Under Maintenance': 'está desactivado - En mantenimiento',
  'is Disabled by Local Control Switch': 'está desactivado por el interruptor de control local',
  'is Disabled by Cloud Control Switch': 'está desactivado por el interruptor de control de la nube',
  'IN MAINTENANCE': 'EN MANTENIMIENTO',
  EnergySavings: 'Ahorros de energía',
  'LIFE TIME SAVINGS': 'AHORROS DE POR VIDA',
  'Unarchive Alert': 'Desarchivar alerta',
  'archive alert failed': 'Ha fallado el archivo de alertas',
  'Select All': 'Seleccionar todo',
  'Archive Selected Alerts': 'Archivar alertas seleccionadas',
  'Restore default': 'Restaurar valores predeterminados',
  'Devices Names': 'Nombres de dispositivos',
  Close: 'Cerrar  ',
  Activity: 'Actividad',
  'Value may depend on multiple sensors.': 'El valor puede depender de varios sensores.',
  Minutes: 'Minutos',
  'kW based Calculation': 'Cálculo basado en kW',
  'Target Setpoint': 'Punto de ajuste objetivo',
  'PRESSURE SET POINTS': 'PUNTOS DE AJUSTE DE PRESIÓN',
  'Water Temperature': 'Temperatura del agua',
  'Set point': 'Punto de ajuste',
  'DEW POINT': 'PUNTO DE ROCÍO',
  'NEXT SERVICE': 'PRÓXIMO SERVICIO',
  ACTIVTY: 'ACTIVIDAD',
  'In maintenance': 'En mantenimiento',
  'Device Details': 'Detalles del dispositivo',
  'This feature is currently disabled.': 'Esta función está desactivada actualmente.',
  Revert: 'Revertir ',
  'Open Insights': 'Abrir perspectivas',
  'Sign in without Single Sign On': 'Iniciar sesión sin Inicio de sesión único',
  'CO2 Reduction': 'Reducción de CO2',
  'Filter by rule': 'Filtrar por regla',
  Target: 'Objetivo',
  'Compressor Type': 'Tipo de compresor',
  'Not Connected': 'No conectado',
  'Keep Alive': 'Mantener la conexión',
  '9 to 13 digits are allowed': 'Se permiten 9 a 13 dígitos',
  Notifications: 'Notificaciones',
  'Station Switch': 'Cambio de estación',
  'Yearly View': 'Vista anual',
  Jan: 'Ene',
  Feb: 'Feb',
  Mar: 'Mar',
  Apr: 'Abr',
  May: 'May',
  Jun: 'Jun',
  Jul: 'Jul',
  Aug: 'Ago',
  Sep: 'Sep',
  Oct: 'Oct',
  Nov: 'Nov',
  Dec: 'Dic',
  Search: 'Buscar',
  influentFlow: 'Flujo afluente',
  dissolvedOxygen: 'Oxígeno disuelto',
  pH: 'pH',
  ammoniaAmmonium: 'Amoníaco (NH3)/Amonio (NH4+)',
  nitrate: 'Nitrato (NO3-)',
  nitrite: 'Nitrito (NO2-)',
  oxidationReductionPotential: 'Potencial de reducción de la oxidación  ',
  influentFlowSensor: 'Sensor de $t(flujo influente)',
  dissolvedOxygenSensor: 'Sensor de $t(oxigeno disuelto)',
  phSensor: 'Sensor de $t(pH)',
  ammoniaAmmoniumSensor: 'Sensor de $t(amoníacoAmonio) ',
  nitrateNO3Sensor: 'Sensor de $t(nitrato)',
  nitriteNO2Sensor: 'Sensor de $t(nitrito)',
  oxidationReductionPotentialSensor: 'Sensor de $t(Potencial de reducción de oxidación)',
  'm3/hour': 'm<0>3</0>/hora',
  GPM: 'GPM',
  blowerSpeed: 'Velocidad del ventilador % (RPM)',
  frequency: 'Frecuencia',
  Hz: 'Hz',
  blower: 'Ventilador',
  aerationBasin: 'Depósito de aireación',
  'kWh/MG': 'kWh/MG',

  // Station Parameters Tab
  validationForGreaterThan: '{{title}} debe ser mayor que {{min}} {{unit}}.',
  validationForMinTargetLessThanMaxTarget: 'El objetivo mínimo debe ser inferior al objetivo máximo.',
  validationForMinMax: '{{title}} debe estar entre {{min}} y {{max}} {{unit}}.',
  targetPressure: 'Presión objetivo',
  offsetFromTargetPressure: 'Banda muerta desde la presión objetivo en la que equilibrar la carga',
  pressureForReloadingCompressor: 'Presión para recargar un compresor',
  pressureForStartingCompressor: 'Presión para el arranque de un compresor',
  pressureForEmergencyStart: 'Presión para el arranque de emergencia de un compresor',
  minLoadedCompressors: 'Número mínimo de compresores cargados',
  pressureFactor: 'Desfase de presión en la prueba de descarga',
  minFrequency: 'Retardo del intento de descarga',
  minPressureSafetyMargin: 'Margen mínimo de seguridad de presión',
  minCompressorStartInterval: 'Intervalo mínimo de arranque del compresor',
  minCompressorRestartInterval: 'Intervalo mínimo de reinicio del compresor',
  flowPeakBuffer: 'Tampón de flujo máximo',
  minIntervalHighFlowTrigger: 'Intervalo mínimo desde la activación del flujo alto',
  setpointChangeInterval: 'Frecuencia del desfase en la prueba de descarga',
  kpiIntervalRetrieval: 'Intervalo de recuperación de KPI',
  loadBalancingPressureFactor: 'Desfase de presión para balanceo de carga',
  emergencyStartFrequency: 'Frecuencia de inicio de emergencia',
  bovMin: 'Valor promedio mínimo de la válvula BOV para la prueba de descarga',
  bovMax: 'Umbral de la válvula BOV para descargar durante la prueba',
  fullLoadPressureBuffer: 'Tope de presión a plena carga',
  unloadTestingFlowBufferPercentage: 'Porcentaje del búfer de flujo de prueba de descarga',
  required: 'Requerido',
  errorSavingEngineConfig: 'Error al guardar la configuración del motor. Vuelva a intentarlo más tarde.',
  maxTarget: 'Objetivo máx',
  minTarget: 'Objetivo mín',
  priority: 'Prioridad',
  timeBetweenUnoadingStop: 'Tiempo entre descarga y parada (mín.)',
  viewReport: 'Visualizar informe',
  searchStation: 'Buscar estación',
  'Nothing to update. No changes were made to the information':
    'Nada para actualizar. No se han realizado cambios en la información',
  comments: 'Comentarios:',
  provideReason: 'Por favor, indique el motivo.',
  probabilityofreducingstationpressurebelowminimum:
    'Probabilidad de reducir la presión de la estación por debajo de la mínima.',
  probabilityofreducingsavingsbelowthecommitment: 'Probabilidad de reducir los ahorros por debajo del compromiso.',
  probabilityofharmingcompressorshealth: 'Probabilidad de dañar la salud del compresor - seleccione el compresor.',
  probabilityofincreasingstationpressure: 'Probabilidad de aumentar la presión de la estación.',
  edgecasenotproperlycovered: 'Los casos límite no están cubiertos adecuadamente.',
  problematicFlowLevels: 'Niveles de flujo problemáticos',
  problematicPressureRanges: 'Rangos de presión problemáticos',
  compressorRapidCycling: 'Ciclos rápidos del compresor',
  problematicSetpointsForCompressor: 'Puntos de ajuste problemáticos para el compresor',
  probabilityOfStationHighPressureValues: 'Probabilidad de valores altos de presión en la estación',
  extremeUsecasesAreNotProperlyCovered: 'Los casos de uso extremos no están debidamente cubiertos',
  refreshEngine: 'Si actualizó la versión del motor, actualice para editar los parámetros',
  compressorSetpointsOrderInfo:
    'Los puntos de ajuste del compresor en cada tabla deben reflejar el orden asignado en la columna OR.',
  viewOnly: 'Modo sólo visualización (motor 1.0)',
  changeEngineVersion: 'Cambiar a 1.5 para administrar ',
  publishConfirmation: 'Se publicarán todas las configuraciones de las pestañas. Confirmar para continuar.',
  publishedOn: 'Publicado el ',
  draftPublishedOn: 'Borrador publicado el ',
  incompleteStationParameters: 'Parámetros de estación incompletos',
  incompleteCompressorParameters: 'Parámetros del compresor incompletos',
  compressorParametersMissing: 'Faltan algunos parámetros del compresor.',
  stationParametersMissing: 'Faltan algunos parámetros de la estación.',
  errorSavingDraft: 'Error al guardar el borrador.',
  errorSavingDraftdesc: 'Complete todos los campos obligatorios tanto para la estación como para los compresores.',
  success: 'éxito',
  error: 'error',
  draftSaved: 'Borrador guardado correctamente.',
  draftSavedDesc: 'Sus cambios se han guardado. Recuerde publicar cuando esté listo.',
  errorSavingChanges: 'Se produjo un error al guardar sus cambios.',
  errorRevertLastPublished: 'Error al volver a la última publicación',
  errorRevertLastPublishedDesc: 'Se produjo un error al volver a la última versión publicada.',
  successPublish: 'Cambios publicados con éxito',
  successPublishDesc: 'El controlador dinámico funciona ahora con los parámetros publicados.',
  errorDraftPublish: 'Error al publicar el borrador',
  errorDraftPublishDesc: 'Se produjo un error al publicar sus cambios.',
  publishChanges: 'Publicar cambios',
  revertToLastPublished: 'Volver a la última publicación',
  confirmPublish: 'Confirmar cambios de publicación',
  publishChange: 'Publicar cambio',
  reviewAgain: 'Revisar de nuevo',
  advancedSettings: 'Ajustes avanzados',
  stopDelayMinutes: 'Detener minutos de retraso',
  maxFlow: 'Flujo máximo',
  maxLoadAmps: 'Amperios de carga máxima',
  fiveLoop: '5 bucle',
  noBaseline: 'Sin referencia',
  noDefaultBaselineStrategy: 'Por el momento no se dispone de una estrategia de referencia predeterminada',
  revertToDefaultBaselineStrategy:
    '¿Está seguro de que desea sustituir el borrador existente con las configuraciones básicas predeterminadas?',

  // Station Stages
  stationStageUpdating: 'Actualizando etapa...',
  stationStageUpdated: 'Etapa actualizada correctamente',
  stationStageError: 'Error al actualizar la etapa. Vuelva a intentarlo de nuevo.',
  stationStageNoStageSelected: 'Ninguna etapa seleccionada',
  stationStageState: 'Estado',
  stationStageMoveTo: 'Mover a',
  stationStageStatus: 'Estado de la estación',
  stationStageDeprecateTitle: 'Estación obsoleta',
  stationStageDeprecateWarning:
    'Está a punto de mover esta estación a un estado obsoleto. Esta acción hará lo siguiente:',
  stationStageDeprecateConsequences1: 'Desactivar todos los controles del sistema para la estación.',
  stationStageDeprecateConsequences2: 'Impedir que se sigan recopilando y actualizando datos.',
  stationStageDeprecateConsequences3: 'Archivar la estación para referencia histórica.',
  stationStageDeprecateConfirm: '¿Está seguro de que desea continuar? Esta acción no puede deshacerse.',
  stationStageDeprecateButton: 'Estación obsoleta',
  stationStageCancelButton: 'Cancelar',
  //installtion validation tab
  INSTALLATION_VALIDATION_TITLE: 'Validación de la instalación',
  INSTALLATION_VALIDATION_SUBMITTED_TITLE: 'Validación ya presentada',
  INSTALLATION_VALIDATION_SUBMITTED_CONTENT:
    'Otro usuario ya ha enviado esta validación. Actualice la página para ver el estado actual.',
  INSTALLATION_VALIDATION_IN_PROGRESS_TITLE: 'Validación en curso',
  INSTALLATION_VALIDATION_IN_PROGRESS_CONTENT:
    'Otro usuario ya ha iniciado esta validación. Actualice la página para ver el estado actual.',
  NOT_AVAILABLE: 'N/C',
  TESTING_IN_PROGRESS: 'Pruebas en curso {{time}}',
  UNRESOLVED_COMPRESSORS_TITLE: 'Estados no resueltos del compresor',
  UNRESOLVED_COMPRESSORS_DESC:
    '{{count}} compresores no pasaron la prueba. Proporcione un comentario o un motivo para cada uno antes de enviar el informe',
  TEST_SUCCESS_TITLE: 'Prueba completada con éxito',
  TEST_SUCCESS_DESC: 'Todos los estados de los compresores han pasado con éxito la prueba.',
  REPORT_SUBMIT_SUCCESS: 'Informe completado con éxito',
  REPORT_SUBMIT_ERROR: 'Error al presentar el informe',
  TEST_NOT_INITIATED_TITLE: 'La prueba no se inició correctamente',
  TEST_NOT_INITIATED_DESC: 'La prueba no se ha iniciado correctamente, por favor, inicie la prueba de nuevo.',
  LOAD_TEST: 'Cargar prueba',
  UNLOAD_TEST: 'Descargar prueba',
  PASSED: 'Pasada',
  FAILED: 'Fallida',
  TESTING: 'Probando...',
  NOT_TESTED: 'No probado',
  NOT_STARTED: '',
  VIEW_COMMENT: 'Ver comentario',
  ADD_COMMENT: 'Añadir comentario',
  NO_POWER_SENSOR: 'Sin sensor de potencia',
  UNRESOLVED_COMPRESSORS_MESSAGE:
    'los compresores no pasaron la prueba. Proporcione un comentario o un motivo para cada uno antes de enviar el informe',
  SUBMIT_CONFIRMATION_MESSAGE:
    'Al enviar el informe de la prueba, indica que la instalación está completa y lista para su revisión',
  BACK_TO_LIST: 'Regresar a la lista',
  TEST_AGAIN: 'Probar de nuevo',
  SUBMIT_REPORT: 'Presentar el informe',
  CANCEL: 'Cancelar',
  'Flow sum': 'Suma del flujo ',
  unresolvedCompressorStates: 'Estados no resueltos del compresor',
  confirmSubmission: 'Confirmar envío',
  testCompletedSuccessfully: 'Prueba completada con éxito',
  commentsInfo: 'Los comentarios sólo se guardarán en el informe enviado.',
  comment: 'Comentario',
  loadTestFailed: 'Error de carga de la prueba',
  unloadTestFailed: 'Error de descarga de la prueba',
  loadTestNotTested: 'No se ha realizado la carga de la prueba',
  unloadTestNotTested: 'No se ha realizado la descarga de la prueba',
  okCamelCase: 'Ok',
  flowTestFailed: 'Error en la prueba de flujo',
  flowTestNotTested: 'No se ha realizado la prueba de flujo',
  START_TEST: 'Iniciar prueba',
  END_TEST: 'Finalizar prueba',
  TEST_DATE: 'Fecha de la prueba: {{date}}',
  SAVE_CHANGES: 'Guardar cambios',
  ADD: 'Añadir',
  compressorMetrics: 'Métricas del compresor',
  noMetricsAvailable: 'No hay métricas disponibles',
  loadBand1: 'Cargar banda 1',
  loadBand2: 'Cargar banda 2',
  unloadBand1: 'Descargar banda 1',
  unloadBand2: 'Descargar banda 2',
  sensorsKPIConfiguration: 'Configuración de los KPI de los sensores',
  flowSensorKPI: 'KPI del sensor de flujo',
  pressureSensorKPI: 'KPI del sensor de presión',
  moreActions: 'Más acciones',
  StationStatus_Inactive: 'El controlador dinámico está inactivo',
  StationStatus_oneDotZeroActive: 'El controlador dinámico 1.0 está activado',
  StationStatus_oneDotFiveActive: 'El controlador dinámico 1.5 está activado',
  StationStatus_oneDotZeroUnderMaintenance: 'El controlador dinámico 1.0 está desactivado - En mantenimiento',
  StationStatus_oneDotFiveUnderMaintenance: 'El controlador dinámico 1.5 está desactivado - En mantenimiento',
  StationStatus_oneDotFiveActiveFallback: 'El controlador dinámico 1.5 está activado',
  StationStatus_oneDotZeroDisabled: 'El controlador dinámico 1.0 está desactivado',
  StationStatus_oneDotFiveDisabled: 'El controlador dinámico 1.5 está desactivado',
  StationStatus_offline: 'Desconectado',
  theme: 'Tema',
  dark: 'Oscuro',
  light: 'Claro',
  measurementSystem: 'Unidad de medición',
  en: 'Inglés',
  fr: 'Francés',
  de: 'Alemán',
  metric: 'Métrico',
  imperial: 'Sistema imperial',
  SelectReason: 'Seleccione un motivo',
  missingSpec: 'Falta la especificación',
  stationControlDefaultSetpointsBaseline:
    'Está a punto de desactivar el Controlador Dinámico de Ecoplant. La estación volverá a los valores predeterminados de referencia. Por favor, confirme y comparta el motivo de la desactivación.',
  stationControlDefaultSetpointsCustom:
    'Está a punto de desactivar el Controlador Dinámico de Ecoplant. La estación volverá a los valores personalizados. Por favor, confirme y comparta el motivo de la desactivación.',
  deactivationContent:
    'Desactivar el controlador dinámico puede afectar las operaciones del sistema. Por favor, confirme y comparta el motivo de la desactivación.',
  userUnitOfMeasure: 'Unidad de medición del usuario',
  // Engine Validation Modal
  engineValidationTitle: 'Validación del estado del motor',
  engineValidationMessage:
    'No se puede cambiar el estado de la estación desde "Suscripción" mientras el motor esté activo. Asegúrese de desactivar el motor antes de cambiar el estado de la estación.',
  flowlevels: 'Niveles de flujo',
  pressureranges: 'Rangos de presión',
  wrongcompressorcombinations: 'Combinación incorrecta de compresores - Seleccionar tabla',
  pressuredrop: 'Caída de presión - Seleccionar tabla',
  setpointsforcompressor: 'Puntos de ajuste para el compresor - seleccionar compresor + seleccionar tabla',
  fallbackcoverage: 'Cobertura de respaldo',
  possiblecause: 'Causa posible:',
  selecttables: 'Seleccionar tablas',
  selectReasonError: 'Por favor seleccione una razón para el rechazo',
  selectCauseError: 'Por favor seleccione una causa posible para el rechazo',
  selectCompressorError: 'Por favor seleccione al menos un compresor para la razón',
  selectCompressorCauseError: 'Por favor seleccione al menos un compresor para la causa posible',
  selectTableError: 'Por favor seleccione al menos una tabla',
  commentLengthError: 'El comentario debe tener entre 2 y 200 caracteres',
  causeCommentLengthError: 'El comentario de la causa posible debe tener entre 2 y 200 caracteres',
  searchByNumber: 'Buscar por número',
  selectAtleastOneCompressor: 'Por favor seleccione al menos un compresor para la falla del compresor.',
  flowKPIOrPressureKPI: 'KPI de flujo o KPI de presión',
  compressorFailure: 'Falla del compresor',
  appliedFilters: 'Filtros aplicados',
  scenario: 'Escenario',
  scenarioName: 'Nombre del escenario',
  selectScenario: 'Seleccionar escenario',
  selectCompressors: 'Seleccionar compresores',
  ignoreFallbackCompressors: 'Compresores excluidos de la generación de escenarios de respaldo',
  ignoreFallbackCompressorsTooltip:
    'Los escenarios de respaldo se generan solo para un conjunto definido de compresores. Este conjunto se determina por la intersección de:',
  ignoreFallbackCompressorsTooltipBullet1: 'Compresores actualmente disponibles en el sistema',
  ignoreFallbackCompressorsTooltipBullet2: 'Compresores no incluidos en la lista de exclusión.',
  ignoreFallbackCompressorsTooltipNote:
    'Los compresores listados aquí son intencionalmente ignorados por la estrategia de respaldo—por ejemplo, porque se sabe que están desconectados o porque no se requiere respaldo si fallan.',
  saveScenario: 'Guardar',
  newFallbackScenario: 'Nuevo escenario de respaldo',
  createACustomTable: 'Crear una tabla personalizada',
  useExistingTable: 'Usar tabla existente',
  createANewFallbackScenario: 'Crear un nuevo escenario de respaldo',
  pickOneToBuildOnEitherReuseAnExistingTableOrLetTheEngineSuggestASmartStartingPoint:
    'Elija uno para comenzar. Reutilice una tabla existente o deje que el motor sugiera un punto de partida inteligente.',
  selectATableNumber: 'Seleccionar un número de tabla',
  filterFailScenario: 'Filtrar escenario fallido',
  refineScenariosByKPIAndComponents: 'Refinar escenarios por indicadores y componentes',
  validationError: 'Error de validación',
  baseFallbackOnTable: 'Basar respaldo en la tabla',
  AND: 'Y',
  scenarioBasedOn: 'Escenario basado en',
  failureOf: 'Falla de',
  flowKPIOrPressureKPIFailure: 'Fallo de KPI de flujo o KPI de presión',
  newFallback: 'Nuevo Respaldo',
  currentlyActive: 'Actualmente activo',
  view: 'Ver',
  removeScenario: 'Eliminar',
  updateScenario: 'Actualizar',
  firstApplyFiltersToDefineYourScenario: 'Primero aplique filtros para definir su escenario',
  applyFiltersAndContinue: 'Aplicar filtros y continuar',
  fallbackScenarioSavedSuccessfully: 'Escenario de respaldo guardado correctamente',
  thisScenarioAlreadyExists: 'Este escenario ya existe.',
  confirmSaveScenario:
    'Guardando escenario de respaldo, se actualizará el borrador. ¿Está seguro de que desea guardar este escenario?',
  confirmUpdateScenario:
    'Actualizando escenario de respaldo, se actualizará el borrador. ¿Está seguro de que desea actualizar este escenario?',
  confirmRemoveScenario:
    'Eliminando escenario de respaldo, se actualizará el borrador. ¿Está seguro de que desea eliminar este escenario?',
  fallbackScenario: 'Respaldo',
  flowKPI: 'KPI de flujo',
  pressureKPI: 'KPI de presión',
  invalidScenario:
    'Escenario inválido como Falla del compresor, Fallo de KPI de flujo, y Fallo de KPI de presión no pueden ser aplicados juntos.',
  set0ForACompressor: 'Establecer 0 para un compresor {}',
  trimmer: 'recortadora',
  setNegativeValueForCompressorsNotToBeIncluded:
    'Establezca un valor negativo para los compresores {} que se incluirán',
  not: 'no',
  setPositiveValueForCompressors: 'Establezca un valor positivo para los compresores {}',
  base: 'base',
  orderIsRequired: 'El orden es obligatorio',
  atLeastOneSetpointMustHavePositiveOrder: 'Al menos un punto de ajuste debe tener un orden positivo',
  mixedStationNotSupported: 'El motor 1.5 no admite estaciones mixtas actualmente',
  'Add a link to document': 'Agregar un enlace al documento',
  'Add a link to presentation': 'Agregar un enlace a la presentación',
  'Add a link to report': 'Agregar un enlace al informe',
  'Add link to SCC activity log screenshot': 'Agregar enlace a la captura de pantalla del registro de actividad de SCC',
  'More than one tracking number can be added.': 'Se puede agregar más de un número de seguimiento.',
  'More than one order number can be added.': 'Se puede agregar más de un número de pedido.',
  'Engine version is set by engine expert': 'La versión del motor la establece el experto en motores',
  Skip: 'Omitir',

  // Report Tab Page
  reportDetails: 'Detalles del informe',
  dateCreated: 'Fecha de creación',
  createdBy: 'Creado por',
  status: 'Estado',
  totalReports: 'Informe',
  createNewReport: 'Crear nuevo informe',
  searchByDateCreatorOrStatus: 'Buscar por fecha, creador o estado',
  inProgress: 'En progreso',
  failed: 'Error',
  inDraft: 'Borrador',
  unknown: 'Desconocido',
  failedToDownloadReportFile: 'Error al descargar el archivo del informe',
  downloadingFile: 'Descargando archivo...',
  fileDownloaded: 'Archivo descargado correctamente',
  deleteReport: 'Eliminar informe',
  areYouSureYouWantToDeleteThisReport: '¿Está seguro de que desea eliminar este informe?',
  reportDeletedSuccessfully: 'Informe eliminado correctamente',
  failedToDeleteReport: 'Error al eliminar el informe',
  failedToUploadReport: 'Error al cargar el informe',
  reportUploadedSuccessfully: 'Informe cargado correctamente',
  anErrorOccurred: 'Ocurrió un error',
  onlyPowerPointFilesAllowed: 'Solo se permiten archivos de PowerPoint (.pptx, .ppt)',
  pleaseSelectADateRange: 'Por favor, seleccione un rango de fechas',
  reportRequestedSuccessfully:
    'La generación del informe puede tardar hasta 15 minutos. Una vez completada, el estado en esta pantalla cambiará a Borrador y se habilitarán las acciones Editar y Publicar.',
  failedToRequestReport: 'Error al solicitar el informe',
  selectDates: 'Seleccionar fechas',
  noteForReportGeneration:
    'Nota: La generación del informe puede tardar unos minutos. Se le notificará por correo electrónico una vez que esté completo.',
  reportTimeFrameUpTo2Weeks: 'El período del informe puede ser de hasta 2 semanas.',
  generateReport: 'Solicitar informe',
  reportPublishedSuccessfully: 'Informe publicado correctamente',
  reportPublishedInProgress:
    'La publicación del informe puede tomar unos minutos. Una vez completada, el estado en esta pantalla cambiará a Publicado, la acción Ansehen se habilitará y el cliente podrá ver este informe.',
  failedToPublishReport: 'Error al publicar el informe',
  addBusinessImpactBeforePublishing: 'Agregar impacto comercial antes de publicar',
  pleaseEstimateItsPotentialBusinessImpact:
    'Por favor, estime su impacto comercial potencial. Esto ayuda a comunicar el valor del informe a su cliente.',
  estimatedValue: 'Valor estimado ($)',
  valueIsRequiredAndMustBeHigherThan0ToPublish: 'El valor es obligatorio y debe ser mayor que 0 para publicar',
  noteOncePublishedThisReportWillBeAutomaticallySharedWithAllRecipients:
    'Nota: Una vez publicado, este informe se compartirá automáticamente con todos los destinatarios.',
  publishReport: 'Publicar informe',
  Upload: 'Cargar',
  Publish: 'Publicar',
  Edit: 'Editar',
  View: 'Ver',
  seeTheFullPictureOfYourReportPerformance: 'Vea el panorama completo del rendimiento de su informe',
  createAToTrackAnalyzeAndSharePerformance: 'Cree un informe para rastrear, analizar y compartir el rendimiento',
  tryNewReport: 'Probar nuevo informe',
  loadingReports: 'Cargando informes...',
  generatingReports: 'Generando informes...',
  noReportsAvailable: 'No hay informes disponibles',

  kpiChanges:
    'Una nueva estrategia de motor debe definirse y publicarse ya que la configuración de los KPI de los sensores ha sido modificada. Por favor, revise los cambios y publique la configuración.',
  kpiChangesAndPIDChanges:
    'Una nueva estrategia de motor debe definirse y publicarse ya que la configuración de la estación P&ID y los KPI de los sensores ha sido modificada. A continuación, se muestra la lista de activos que afectan la estrategia de control:',
  sentForPublishing: 'Enviado para publicación',
  dynamicControlInvalidStationStage:
    'El control dinámico no puede activarse ya que la estación no se encuentra en la etapa de Suscripción/Preparación de control.',
  fallbackScenarioForAllCompressorsFailureCannotBeDefined:
    'No se puede definir un escenario de respaldo para todas las fallas de compresores',
  loadingDocument: 'Cargando documento...',
};

export default en;
